import { FieldCardContent } from '@/core/components/Card/components/FieldCardContent/FieldCardContent'
import { createNavigationCardItem } from '@/core/hooks/useCardNavigation/utils/createNavigationCardItem'
import { getFieldBadgeLabel } from '@/core/hooks/useCardNavigation/utils/getFieldBadgeLabel'
import type { ClassData, FieldData, LibraryData } from '@/core/types/library.type'

interface BuildFieldEntriesParams {
  classData: ClassData
  library: LibraryData
  openAccordions: string[]
  onAccordionToggle: (itemId: string) => void
}

export const buildFieldEntries = ({
  classData,
  library,
  openAccordions,
  onAccordionToggle,
}: BuildFieldEntriesParams) =>
  classData.fields
    ? Object.values(classData.fields).map((field: FieldData) => {
        const badge = getFieldBadgeLabel(field.type)
        const content = <FieldCardContent field={field} classData={classData} runtimeName={library.runtimeName} />

        return createNavigationCardItem({
          id: field.name,
          title: field.name,
          name: field.name,
          badge,
          description: undefined,
          content,
          isOpen: openAccordions.includes(field.name),
          onAccordionToggle,
        })
      })
    : []
